import React from 'react';

const News = () => {
  return (
    <div className="news-page">
      <div className="container">
        <h1>News</h1>
        <p>This is the news page. Content will be added here.</p>
      </div>
    </div>
  );
};

export default News;
